<template>
    <div>
        <div class="tile-container" :class="config" v-if="configuration === '1-2'">
            <div class="mid-container mid-container--1">
                <slot name="1"></slot>
            </div>
            <div class="mid-container mid-container--2">
                <slot name="2.1"></slot>
                <slot name="2.2"></slot>
            </div>
        </div>
        <div class="tile-container" :class="config" v-if="configuration === '2-1'">
            <div class="mid-container mid-container--2">
                <slot name="2.1"></slot>
                <slot name="2.2"></slot>
            </div>
            <div class="mid-container mid-container--1">
                <slot name="1"></slot>
            </div>
        </div>
        <div class="tile-container tile-container--n" :class="config" v-if="configuration === 'n'">
            <slot></slot>
        </div>
    </div>
</template>
<script>
	export default {
		props: [
			"configuration"
		],
        computed: {
			config () {
				return {
					[`configuration_${this.configuration}`]: true
				};
            },
            images () {
				if (this.configuration === 'n') {
					return this.$slots.default.reduce((carry,element) => {
						if (element.tag !== undefined) {
							carry.push(element.componentOptions.propsData);
                        }
                        return carry;
					},[]);
				} else {
					return Object.keys(this.$slots).reduce((carry,key) => {
						if (key !== "default") {
							carry.push(this.$slots[key][0].componentOptions.propsData);
						}
						return carry;
					},[])
				}
            }
        }
	}
</script>
<style lang="scss">
    @import "~foundation-sites/scss/foundation";

    $tile-margin: 5px;

    .tile-container {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .mid-container {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            &--2 {
                .tile {
                    flex: calc(50% - 10px);
                    @include breakpoint (large) {
                        flex: 100%;
                    }
                }
            }
            &--1,
            &--2 {
                width: 100%;
            }
            @include breakpoint (large) {
                &--1 {
                    width: calc(100% * 2/3);
                }
                &--2 {
                    width: calc(100% * 1/3);
                }
            }
        }
        &--n > div.tile {
            flex: 1;
        }
    }

</style>



// WEBPACK FOOTER //
// tile-container.vue?2df82a16